import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-employee',
    templateUrl: './employee.component.html',
    styleUrls: ['./employee.component.css']
})
export class EmployeeComponent implements OnInit {
    imageoneEmployee: boolean = false;
    pageTitle: string;
    pageDisplay: string;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        let url = this.router.url;
        var applicationName = "employeesappelement";
        this.lazyLoadService.loadScript(environment["EMPLOYEEAPPURL"], applicationName).subscribe(_ => {
            if (url == '/employee/add') {
                this.pageTitle = "New Employee";
                this.pageDisplay = "EmpAdd";
            } else if (url == '/employee') {
                this.pageTitle = "Employee List";
                this.pageDisplay = "EmpList";
            } else if(url.includes('/employee/edit')) {
                this.pageTitle = "Update Employee Information";
                this.pageDisplay = "EmpEdit";
            } else if (url == '/user') {
                this.pageTitle = "Users List";
                this.pageDisplay = "UserList";
            } else if (url == '/exportemployee') {
                this.pageTitle = "Export Employee";
                this.pageDisplay = "ExportEmployee";
            } else if(url == '/employee/inactive') {
                this.pageTitle = "Inactive Employee List";
                this.pageDisplay = "InactiveEmpList";
            } else if (url == '/exportinactiveemployee') {
                this.pageTitle = "Export Inactive Employee";
                this.pageDisplay = "ExportInactiveEmployee";
            } else if (url == '/employee/franchise') {
                this.pageTitle = "Franchise Employee List";
                this.pageDisplay = "FranchiseEmpList";
            } else if (url == '/employee/franchise/export') {
                this.pageTitle = "Export Franchise Employees";
                this.pageDisplay = "ExportFranchiseEmp";
            }
            this.imageoneEmployee = true;
        })
    }

    ngOnDestroy(): void {
        this.imageoneEmployee = false;
    }
}